import { render } from "./WhatsAppGroupSend.vue?vue&type=template&id=9791d08e"
import script from "./WhatsAppGroupSend.vue?vue&type=script&lang=js"
export * from "./WhatsAppGroupSend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__